<div class="mb-4 flex flex-wrap items-center justify-between gap-x-4 gap-y-2">
  <!-- Checkbox pour grouper les transports -->
  <div class="flex items-center gap-2">
    <p-checkbox
      inputId="groupTransports"
      [(ngModel)]="groupTransports"
      (onChange)="onGroupTransportsChange($event)"
      binary="true"
      styleClass="p-checkbox-sm"
    ></p-checkbox>
    <label
      for="groupTransports"
      class="flex cursor-pointer items-center gap-1 text-xs text-greyscale-600"
    >
      <lucide-angular
        [img]="routeIcon"
        class="h-3 w-3 text-greyscale-500"
      ></lucide-angular>
      {{ "impact.overview.groupTransports" | transloco }}
    </label>
    <lucide-angular
      [img]="infoIcon"
      class="h-4 w-4 cursor-help text-greyscale-500"
      pTooltip="{{
        'impact.overview.groupTransportsTooltip' | transloco
      }}"
      tooltipPosition="top"
    ></lucide-angular>
  </div>

  <!-- Checkbox pour exclure le transport principal -->
  <div class="flex items-center gap-2">
    <p-checkbox
      inputId="excludeMainTransport"
      [(ngModel)]="excludeMainTransport"
      (onChange)="onExcludeMainTransportChange($event)"
      binary="true"
      styleClass="p-checkbox-sm"
    ></p-checkbox>
    <label
      for="excludeMainTransport"
      class="cursor-pointer text-xs text-greyscale-600"
    >
      {{ "impact.overview.excludeMainTransport" | transloco }}
    </label>
    <lucide-angular
      [img]="infoIcon"
      class="h-4 w-4 cursor-help text-greyscale-500"
      pTooltip="{{
        'impact.overview.excludeMainTransportTooltip' | transloco
      }}"
      tooltipPosition="top"
    ></lucide-angular>
  </div>

  <!-- Affichage du logo company/client sur le graphique (popover) -->
  @if (logoSources.length > 0) {
    <div class="flex items-center">
      <p-button
        (click)="logoPopover.toggle($event)"
        [pTooltip]="'impact.overview.logo.tooltip' | transloco"
        tooltipPosition="top"
        [tooltipOptions]="{ showDelay: 500 }"
        icon="pi pi-image"
        severity="secondary"
        size="small"
        [rounded]="true"
      />
      <p-popover #logoPopover>
        <div class="flex min-w-[240px] max-w-[300px] flex-col p-1">
          <div
            class="mb-3 flex flex-col gap-1 border-b border-greyscale-100 pb-3"
          >
            <div class="flex items-center gap-2">
              <i class="pi pi-image text-primary-500"></i>
              <span class="text-sm font-semibold text-greyscale-800">
                {{ "impact.overview.logo.label" | transloco }}
              </span>
            </div>
            <p class="text-xs leading-snug text-greyscale-500">
              {{ "impact.overview.logo.tooltip" | transloco }}
            </p>
          </div>
          <div class="flex flex-col gap-3">
            <div class="flex flex-col gap-1">
              <span class="text-xs font-medium text-greyscale-600">
                {{ "impact.overview.logo.position" | transloco }}
              </span>
              <p-selectButton
                [options]="logoPositionOptions"
                [ngModel]="logoPosition"
                (onChange)="onLogoPositionChange($event.value)"
                optionLabel="label"
                optionValue="value"
                styleClass="p-selectbutton-sm"
                size="small"
              ></p-selectButton>
            </div>
            @if (logoPosition !== "none" && logoSources.length > 1) {
              <div class="flex flex-col gap-1">
                <span class="text-xs font-medium text-greyscale-600">
                  {{ "impact.overview.logo.source" | transloco }}
                </span>
                <p-select
                  [options]="logoSources"
                  [ngModel]="logoSourceId"
                  (onChange)="onLogoSourceChange($event.value)"
                  optionLabel="name"
                  optionValue="id"
                  size="small"
                  appendTo="body"
                ></p-select>
              </div>
            }
          </div>
        </div>
      </p-popover>
    </div>
  }
</div>
